import { StatusTone } from '@/components/ui/statusTone.ts';
import { EmailSettingStatus } from '@/features/dashboard/emailSender/types/EmailSettingStatus.ts';

export const emailSettingStatusLabels: Record<EmailSettingStatus, string> = {
  [EmailSettingStatus.REQUESTED]: 'Oczekuje na zatwierdzenie',
  [EmailSettingStatus.APPROVED]: 'Aktywny',
  [EmailSettingStatus.REJECTED]: 'Odrzucony',
  [EmailSettingStatus.SUSPENDED]: 'Zawieszony',
};

export const getEmailSettingStatusLabel = (status: string): string => {
  return emailSettingStatusLabels[status as EmailSettingStatus] ?? status;
};

export const emailSettingStatusTones: Record<EmailSettingStatus, StatusTone> = {
  [EmailSettingStatus.REQUESTED]: 'warning',
  [EmailSettingStatus.APPROVED]: 'success',
  [EmailSettingStatus.REJECTED]: 'error',
  [EmailSettingStatus.SUSPENDED]: 'error',
};
